module.exports = __webpack_public_path__ + "img/step36_a_connect_side_blockers.ef9cc860.png";